var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonSimpleStorageService32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Simple-Storage-Service_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B660F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CAE3E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Simple-Storage-Service_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-Simple-Storage-Service_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5322,17.3911 L26.7292,15.9321 C28.8212,17.1311 28.8642,17.6261 28.8632149,17.6401 C28.8592,17.6431 28.5092,17.9231 26.5322,17.3911 L26.5322,17.3911 Z M25.5642,17.1031 C22.7222,16.2061 18.9042,14.5311 16.7232,13.5041 C16.7232,13.4971 16.7272,13.4911 16.7272,13.4841 C16.7272,12.8211 16.1872,12.2811 15.5242,12.2811 C14.8612,12.2811 14.3212,12.8211 14.3212,13.4841 C14.3212,14.1481 14.8612,14.6871 15.5242,14.6871 C15.8142,14.6871 16.0702,14.5711 16.2782,14.4001 C17.5472,14.9941 22.0752,17.0761 25.4282,18.1131 L24.2492,26.8501 C24.2492,27.7161 20.5752,29.0001 15.5002,29.0001 C10.4252,29.0001 6.7512,27.7161 6.7462,26.7841 L4.2832,8.5631 C6.4582,10.1551 11.0742,11.0001 15.5002,11.0001 C19.9262,11.0001 24.5432,10.1551 26.7182,8.5631 L25.5642,17.1031 Z M4.0032,6.4891 C4.0322,5.6091 8.1042,3.0001 15.5002,3.0001 C22.8952,3.0001 26.9702,5.6091 27.0002,6.4891 L27.0002,6.6031 C26.8102,8.2311 22.1372,10.0001 15.5002,10.0001 C8.8632,10.0001 4.2092,8.2311 4.0182,6.6041 L4.0032,6.4891 Z M28.0002,6.5001 C28.0002,4.6651 23.1312,2.0001 15.5002,2.0001 C7.8692,2.0001 3.0002,4.6651 3.0002,6.5001 L3.0002,6.5671 L5.7512,26.8501 C5.7512,28.8961 10.7732,30.0001 15.5002,30.0001 C20.2262,30.0001 25.2492,28.8961 25.2442,26.9171 L26.3962,18.3901 C27.2172,18.6041 27.8812,18.7181 28.3922,18.7181 C28.9852,18.7181 29.3862,18.5741 29.6282,18.2851 C29.8272,18.0471 29.9032,17.7601 29.8452,17.4541 C29.7082,16.7161 28.7972,15.9191 26.8902,14.8701 L26.8692,14.8961 L28.0002,6.5671 L28.0002,6.5001 Z",
    id: "Amazon-Simple-Storage-Service-Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonSimpleStorageService32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Simple-Storage-Service_32.39063883b6854d07eb8e9efb37746bd1.svg";
export { ForwardRef as ReactComponent };